import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import topic from 'dojo/topic';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './GenericDialog.html?raw';
import { _TabEnabledMixin } from "../../_loadingHelpers/Tabbing";
import FloatingMenu from '../Floating/Menu';
import { DOMhelpers, HtmlHelpers, TranslationHelpers } from "../../../more/Helpers";
import { GenericDialogTypes } from "./GenericDialogTypes";
//import DataItems = require("DataItems");


interface DlgButton {
    node: HTMLElement,
    name: string,
    label: string,
    tooltip: string,
    callback: Function,
    closeOnClick?: boolean,
    styleclass: string,
    iconclass: string,
    isSecondary: boolean;
    enabled: boolean;
    hasNextLevel?: boolean;
    hasPreviousLevel?: boolean;
    groupname?: string;
    order: number;
}

interface SecondaryMenuGroup {
    name: string,
    label?: string,
    iconClass?: string,
    bIsGroupNextLevel?: boolean,
    parentGroupName?: string
}
class GenericDialog extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private titleActionContainer: HTMLDivElement;
    private headerBarNode: HTMLDivElement;
    private headerIconNode: HTMLDivElement;
    private headerLabelNode: HTMLDivElement;
    modalDlgNode: HTMLDivElement;
    private topCloseBtn: HTMLDivElement;
    private topResizeBtn: HTMLDivElement;
    subTitleNode: HTMLDivElement;
    bottomSubTitleNode: HTMLDivElement;
    textNode: HTMLDivElement;
    contentContainer: HTMLDivElement;
    modalDlgContentNode: HTMLDivElement;
    private textIconContainer: HTMLDivElement;
    private textIconNode: HTMLElement;
    private btnSecondaryMenu: HTMLElement;
    private secondaryIconsContainer: HTMLElement;
    private furtherEntriesIcon: HTMLElement;

    actionContainerNode: HTMLDivElement;
    menuActionContainerNode: HTMLDivElement;
    rightActionContainerNode: HTMLDivElement;
    leftActionContainerNode: HTMLDivElement;

    secondaryButtonsAsMenu: boolean = true;

    //btnUserdefinedLabel: HTMLSpanElement;
    //btnUserdefined: HTMLDivElement;
    //btnUserdefinedIcon: HTMLElement
    //btnUserdefinedSecondaryLabel: HTMLSpanElement;
    //btnUserdefinedSecondary: HTMLDivElement;
    //btnUserdefinedSecondaryIcon: HTMLElement

    private btnYes: HTMLDivElement;
    private btnNo: HTMLDivElement;
    private btnOk: HTMLDivElement;
    private btnCancel: HTMLDivElement;
    private btnClose: HTMLDivElement;
    private btnBack: HTMLDivElement;
    private btnNext: HTMLDivElement;

    callback: Function = null;
    private callbackCancelNoClose: Function = undefined;
    private isUseDistinctiveCallbacks: boolean = false;
    private callbackConfig: GenericDialogTypes.CallbackConfig = null;

    destroyOnClose: boolean = true;
    private buttoncount: number = 0;


    private defaultUrl: string = null; // for the history manipulation
    private dlgOpenUrl: string = "#GenericDialog_open";
    private initialState: object;
    private onpopstateCallbackName: string = "_onpopstateCallback_genericDialog";
    private activeState: object = { name: "genericDialogOpen", widgetID: "", };
    private closedState: object = { name: "genericDialogClosed", widgetID: "" };
    // der user hat sich mit vor- zurück und reload ausgetobt und wir wissen das initiale State nich - setzen wir eigenen
    private customState: object = { name: "initialState_genericDialog", widgetID: "" };

    closeOnEnter: boolean = false;
    closeOnEscape: boolean = true;
    keepOpen: boolean = false;

    is_active: boolean = false;

    propagateClick: boolean = false;

    private _isMobile: boolean = false;
    _standbyTargetNodeName: "textNode"; //string//HTMLElement = this.textNode;

    // das hier ist generisch. 1x pro instanziierung aufgerufen. modifiziere this[this.activeState["onpopstateCallback"]]
    private _onpopstateCallback_setup(evt?): void {

        if (this._isMobile === true) {
            // für jede instanz eigenen callback in die window property setzen // soll später vererbt werden
            if (history.state != null) {
                window.addEventListener("popstate", lang.hitch(this, this.onpopstateCallbackName));
                if (history.state["widgetID"] == this.id) {
                    this[this.onpopstateCallbackName]();
                }
            }
        } else {
            alert("start the widget in mobile version for the mobile version to work")
        }
    }

    // custom callback für diese instanz. bei jedem state kann man somit eigene callbacks registrieren. this._onpopstateCallback_setup() immer aufrufen
    private _onpopstateCallback_genericDialog(evt): void {
        console.debug("history popstate", history, window["widgetsRoutingOrder"]);
        if (this._isMobile === true) {
            if (history?.state?.name == this.initialState["name"] || history.state == null) {
                if (this.is_active === true) {
                    this._close();
                } else {
                    //
                }
            } else if (window["widgetsRoutingOrder"] && window["widgetsRoutingOrder"].length && window["widgetsRoutingOrder"].indexOf(this.id) == (window["widgetsRoutingOrder"].length - 1)) {
                this._close();
            }
        } else {
            alert("start the widget in mobile version for the mobile version to work")
        }


    }

    private _onClick_Close(evt: Event): void {
        if (this.propagateClick !== true) {
            evt.stopPropagation();
        }
        this.keepOpen = false;
        this._close(0);
    }

    private _onClick_Button_Cancel(evt: any): void {
        if (this.propagateClick !== true) {
            evt.stopPropagation();
        }

        this._close(0);
    }
    private _onClick_Button_OK(evt: any): void {
        if (this.propagateClick !== true) {
            evt.stopPropagation();
        }
        this._close(1);
    }

    private _onClick_Button_YES(evt: any): void {
        if (this.propagateClick !== true) {
            evt.stopPropagation();
        }
        this._close(2);
    }

    private _onClick_Button_NO(evt: any): void {
        if (this.propagateClick !== true) {
            evt.stopPropagation();
        }
        this._close(-1);
    }

    private _onClick_Button_Close(evt: any): void {
        if (this.propagateClick !== true) {
            evt.stopPropagation();
        }
        this._close(0);
    }

    private _onClick_Button_NEXT(evt: any): void {
        if (this.propagateClick !== true) {
            evt.stopPropagation();
        }
        this._close(3);
    }

    private _onClick_Button_BACK(evt: any): void {
        if (this.propagateClick !== true) {
            evt.stopPropagation();
        }
        this._close(4);
    }


    _setCallbackAttr(value: Function, noCancelCloseCallback?: Function) {
        this.callback = value;

        if (typeof (noCancelCloseCallback) == "function" || noCancelCloseCallback === null) {
            this.setDistinctiveCallbacksMode(true, null, noCancelCloseCallback);
        }
    }

    /**
     * Stellt den Dialog in einen Modus, bei dem das reguläre Callback nur bei Ja, Speichern und OK aufgerufen wird.
     * Nein, Schließen, Abbrechen rufen nur ein Callback auf, wenn dieses hier als callbackNoCancelClose gesetzt wurde
     * @param bUseDistinctiveCallbacks Modus grundsätzlich ein- oder ausschalten. Wenn false, verhält sich der Dialog normal und verwendet immer das allgemeine Callback.
     * @param callbackSucces Optional: neues Callback (bei aktiviertem Distinct-Modus nur für Ja, Speichern und OK genutzt)
     * @param callbackNoCancelClose Optional: Callback, das bei Schließen, Abbrechen oder Nein aufgerufen wird. Bei null wird das bestehende Callback entfernt.
     */
    setDistinctiveCallbacksMode(bUseDistinctiveCallbacks: boolean, callbackSucces?: Function, callbackNoCancelClose?: Function | "silentclose") {
        this.isUseDistinctiveCallbacks = bUseDistinctiveCallbacks !== false;

        if (typeof (callbackSucces) == "function") this._setCallbackAttr(callbackSucces);
        if (callbackNoCancelClose == "silentclose") this.callbackCancelNoClose = null;
        else if (typeof (callbackNoCancelClose) == "function" || callbackNoCancelClose === null) this.callbackCancelNoClose = callbackNoCancelClose;
    }

    private _onClick_Dlg(evt: MouseEvent) {
        if (this.propagateClick !== true) {
            evt.stopPropagation();
        }

        topic.publish("/Global/Click");
    }

    private _onKeyUp_Dlg(evt: KeyboardEvent): void {

        if (this.propagateClick !== true) {
            evt.stopPropagation();
        }


        if (evt.key == "Enter" && this.closeOnEnter === true) {
            let okButtonActive = !this.UiModder.domClass.contains(this.btnOk, "w3-hide");
            let yesButtonActive = !this.UiModder.domClass.contains(this.btnYes, "w3-hide");
            let submitButtonActive = this.getButtonByName("submit") != null;


            let btn = this.getButtonByName("submit");
            if (btn?.enabled) {
                this._close(GenericDialogTypes.GenericDialogResult.ok);
            }

            btn = this.getButtonByName("ok");
            if (btn?.enabled) {
                this._close(GenericDialogTypes.GenericDialogResult.ok);
            }

            btn = this.getButtonByName("yes");
            if (btn?.enabled) {
                this._close(GenericDialogTypes.GenericDialogResult.yes);
            }
            

            this._close(submitButtonActive ? 1 : yesButtonActive ? 2 : okButtonActive ? 1 : 0); // bei submit 1, ja 2, ok mit 1 schließen, ansonsten mit 0

        }
        if (evt.key == "Escape" && this.closeOnEscape === true) {
            this._close(0);
        }
    }

    hideSubtitleNode(bHide?: boolean, useBottomSubtitle: boolean = false): void {
        if (typeof (bHide) == "undefined") {
            bHide = true;
        }

        let target = this.subTitleNode;
        if (useBottomSubtitle === true) {
            target = this.bottomSubTitleNode;
        }

        if (bHide === true) {
            this.UiModder.domClass.add(target, "w3-hide");
        } else {
            this.UiModder.domClass.remove(target, "w3-hide");
        }
    }

    _setSubTitleAttr(value: string, useBottomSubtitle: boolean = true): void {
        let target = this.subTitleNode;
        if (useBottomSubtitle === true) {
            target = this.bottomSubTitleNode;
        }
        value = TranslationHelpers.tryTranslate(value);

        this.UiModder.domAttr.set(target, "innerHTML", value);
        this.hideSubtitleNode(false, useBottomSubtitle);
    }


    _getSubTitleAttr(bottomSubtitle: boolean = false): string {
        let target = this.subTitleNode;
        if (bottomSubtitle === true) {
            target = this.bottomSubTitleNode;
        }
        return this.UiModder.domAttr.get(target, "innerHTML");

    }

    _setContentAttr(value: string, embedIntoElement?: string | HTMLElement, className?: string): void {
        value = TranslationHelpers.tryTranslate(value);

        if (value) value = this.stringReplaceAll(value, "\n", "<br>");

        if (embedIntoElement) {
            let element: HTMLElement = null;
            if (typeof (embedIntoElement) == "string") {
                element = this.UiModder.domConstruct.create(embedIntoElement);
            } else if (typeof (embedIntoElement) == "object") {
                element = embedIntoElement;
            }

            if (className) this.UiModder.domClass.add(element, className);

            this.UiModder.domAttr.set(element, "innerHTML", value);

            value = element.outerHTML;
        }

        this.UiModder.domAttr.set(this.textNode, "innerHTML", value);
    }

    _getContentAttr(): string {
        return this.UiModder.domAttr.get(this.textNode, "innerHTML");
    }

    addWidgetToContent(widget: dijit._WidgetBase, pos?: "first" | "last" | "bottom") {
        if (!widget) return;
        if (typeof (pos) == "undefined") pos = "last";

        // abfangen obs wirklich ein Widget ist!!
        if (!widget.placeAt) {
            if (widget instanceof HTMLElement) {
                this.addNodeToContent(widget, pos);
            } else if (widget.toString) {
                this._setContentAttr(widget.toString());
            } else if (typeof (widget) == "string") {
                this._setContentAttr(widget);
            }
        }

        if (pos == "bottom") {
            widget.placeAt(this.contentContainer)
            return;
        }


        if (widget instanceof _TabEnabledMixin) {
            //widget.isEmbeddedInTab = true;
            (widget as any).on("requestNewContextButton", lang.hitch(this, this._onRequestNewContextButton));
            (widget as any).on("requestDisableContextButton", lang.hitch(this, this._onRequestContextButtonDisable));
            (widget as any).on("requestRemoveContextButton", lang.hitch(this, this._onRequestContextButtonRemove));
            (widget as any).on("requestTabRename", lang.hitch(this, this._onRequestRename));
        }

        widget.placeAt(this.textNode, pos);
    }

    addNodeToContent(node: HTMLElement, pos?: "first" | "last" | "bottom"): void {
        if (typeof (pos) == "undefined") pos = "last";
        if (pos == "bottom") {
            this.UiModder.domConstruct.place(node, this.contentContainer)
            return;
        }

        

        this.UiModder.domConstruct.place(node, this.textNode, pos);
    }

    addNodeToSubtitle(node: HTMLElement, pos?: "first" | "last", useBottomSubtitle: boolean = false): void {
        if (typeof (pos) == "undefined") pos = "last";
        let target = this.subTitleNode;
        if (useBottomSubtitle === true) {
            target = this.bottomSubTitleNode;
        }

        this.UiModder.domConstruct.place(node, target, pos);

        this.hideSubtitleNode(false, useBottomSubtitle);
    }
    /**
     * Erlaubt eine zweite Größeneinstellung des Dialogs. Der Benutzer erhält einen Button zum Vergrößern oder Verkleinern des Dialogs und kann damit zwischen zwei Einstellungen wechseln.
     * Falls die Alternativgröße bereits die aktuelle ist, gibt es keine Änderung.
     */
    allowResize(alternativeSize: GenericDialogTypes.DialogSize | "none") {
        this.allowSizes(this._currentSize, alternativeSize);
    }
    /**
     * Erlaubt die Einstellung zweier Größen, zwischen denen der User wechseln kann.
     * Wenn eine der Größen bereits die aktuell eingestellte ist, wird die jeweils andere als Alternative hinterlegt.
     * Wenn keine der Größen der aktuellen entspricht, wird size1 übernommen und size2 als Alternative hinterlegt.
     * @param size1
     * @param size2
     */
    allowSizes(size1: GenericDialogTypes.DialogSize, size2: GenericDialogTypes.DialogSize | "none") {
        let newSize: GenericDialogTypes.DialogSize | "none" = null;
        let currentSize: GenericDialogTypes.DialogSize = this._currentSize;

        // ermitteln was schon eingestellt ist und was die tatsächliche neue Größe ist.
        if (size1 == this._currentSize) {
            if (size2 != this._currentSize) {
                newSize = size2;
            }
        } else if (size2 == this._currentSize) {
            if (size1 != this._currentSize) {
                newSize = size1;
            }
        }

        // passt nicht - weder size 1 oder noch size 2 entsprechen der aktuellen Einstellung
        // dann stattdessen einfach übernehmen
        if (!newSize) {
            currentSize = size1;
            newSize = size2;
        }

        this.setSize(currentSize, newSize);
    }
    private _alternativeSize: GenericDialogTypes.DialogSize;
    private _currentSize: GenericDialogTypes.DialogSize = "default";
    setSize(size: GenericDialogTypes.DialogSize, allowResizeTarget?: GenericDialogTypes.DialogSize | "none") {

        if (!allowResizeTarget && size && size == this._alternativeSize) {
            // es gibt eine hinterlegte Alternativgröße und die neue Größe ist genau diese
            // dann einmal switchen und die aktuelle Größe als Alternative hinterlegen:
            this.setSize(this._alternativeSize, this._currentSize);
            return;
        }

        this.UiModder.domClass.remove(this.domNode, "smaller larger largest fullsize widest contentBased")
        switch (size) {
            case "smaller":
            case "larger":
            case "largest":
            case "fullsize":
            case "widest":
            case "contentBased":

                this.UiModder.domClass.add(this.domNode, size);
                this._currentSize = size;
                break;

            default:
            case "default":
                this._currentSize = "default";
                // nix - einfach keine anderen Styles
                break;
        }

        if (this._currentSize == allowResizeTarget) {
            allowResizeTarget = null;
        }

        switch (allowResizeTarget) {
            case "smaller":
            case "larger":
            case "largest":
            case "fullsize":
            case "widest":
            case "contentBased":
            case "default":
                this._alternativeSize = allowResizeTarget;
                break;

            default:
                if (allowResizeTarget === null || allowResizeTarget == "none") {
                    this._alternativeSize = null;
                }
                break;
        }

        this.hideNode(this.topResizeBtn, !this._alternativeSize);
        if (this._alternativeSize) {
            let currentSizeIndex: number;
            let altSizeIndex: number;


            let sizeMap: Record<GenericDialogTypes.DialogSize, number> = {
                "contentBased": 10,
                "smaller": 10,
                "default": 20,
                "larger": 30,
                "largest": 40,
                "widest": 50,
                "fullsize": 100
            };

           

            this.UiModder.domConstruct.empty(this.topResizeBtn);
            let icon = "fas fa-expand-alt";

            if (sizeMap[this._currentSize] > sizeMap[this._alternativeSize]) {
                icon = "fas fa-compress-alt";
            }

            HtmlHelpers.createFontawesomeIcon(icon, null, this.topResizeBtn);
        }
    }

    private _onClick_Resize(evt) {
        if (this._alternativeSize) {
            let currentSize = this._currentSize;
            this.setSize(this._alternativeSize, currentSize);
        }
    }

    setGlow(hexColorMain: string, hexColorSecondary?: string) {
        // TODO...
        if (!hexColorMain) {
            this.UiModder.domClass.remove(this.domNode, "glow");
            return;
        }

        this.UiModder.domClass.add(this.domNode, "glow");
        this.domNode.style.setProperty("--glowColor", hexColorMain);

        if (hexColorSecondary) {
            this.domNode.style.setProperty("--glowColorSecondary", hexColorSecondary);
        }
    }

    _setHeaderAttr(value: string): void {

        value = TranslationHelpers.tryTranslate(value);

        this.UiModder.domAttr.set(this.headerLabelNode, "innerHTML", value);
    }

    _getHeaderAttr(): string {
        return this.UiModder.domAttr.get(this.headerLabelNode, "innerHTML");
    }

    _toggleHeaderClass(className: string, toggle: boolean): void {
        this.UiModder.domClass.toggle(this.headerLabelNode, className, toggle);
    }

    _setTextIconAttr(iconClass: string | false): void {
        if (typeof (iconClass) != "undefined" && iconClass !== false && iconClass != null) {
            this.UiModder.domClass.remove(this.textIconContainer, "w3-hide");
            this.UiModder.domClass.remove(this.textIconNode);
            this.UiModder.domClass.add(this.textIconNode, iconClass);
        } else {
            this.UiModder.domClass.add(this.textIconContainer, "w3-hide");
            this.UiModder.domClass.remove(this.textIconNode);
        }
    }

    showActionContainer(bool?: boolean): void {
        //console.log("showActionContainer", this.buttoncount);
        if (this.buttoncount < 0) {
            this.buttoncount = 0;
        }

        if (typeof (bool) == "undefined") {
            bool = this.buttoncount > 0;
        }

        if (bool == true) {
            this.UiModder.domClass.remove(this.actionContainerNode, "w3-hide");
        }

        else {
            this.UiModder.domClass.add(this.actionContainerNode, "w3-hide");
        }

        this.hideNode(this.menuActionContainerNode);

        if (this.secondaryButtonsAsMenu) {


            let count = 0;
            for (let button of this._buttons) {
                if (button.isSecondary) {
                    count++;

                    if (count == 2) {
                        this.hideNode(this.leftActionContainerNode, true);
                        this.hideNode(this.menuActionContainerNode, false);
                        break;
                    }
                }
            }
            if (count <= 1) this.hideNode(this.leftActionContainerNode, false);
        } else {
            this.hideNode(this.leftActionContainerNode, false);
        }
    }

    public openDialog(
        title?: string, message?: string, iconClass?: string, buttons?: GenericDialogTypes.ButtonPreset, callbackConfig?: GenericDialogTypes.CallbackConfig) {
        if (title && this.canTranslate(title)) title = this.translate(title);
        if (message && this.canTranslate(message)) message = this.translate(message);
        this.show(message, title, null, iconClass, buttons, lang.hitch(this, this._dialogCallback, callbackConfig));
    }

    private _dialogCallback( response: GenericDialogTypes.GenericDialogResult ) {
        switch (response) {
            case GenericDialogTypes.GenericDialogResult.no:
                if (this.callbackConfig && this.callbackConfig.noCallback && typeof (this.callbackConfig.noCallback) == "function") this.callbackConfig.noCallback();
                else if (this.callback && typeof (this.callback) == "function") this.callback(response);
                break;
            case GenericDialogTypes.GenericDialogResult.cancel:
                if (this.callbackConfig && this.callbackConfig.cancelCallback && typeof (this.callbackConfig.cancelCallback) == "function") this.callbackConfig.cancelCallback();
                else if (this.callback && typeof (this.callback) == "function") this.callback(response);
                break;
            case GenericDialogTypes.GenericDialogResult.ok:
                if (this.callbackConfig && this.callbackConfig.okCallback && typeof (this.callbackConfig.okCallback) == "function") this.callbackConfig.okCallback();
                else if (this.callback && typeof (this.callback) == "function") this.callback(response);
                break;
            case GenericDialogTypes.GenericDialogResult.yes:
                if (this.callbackConfig && this.callbackConfig.yesCallback && typeof (this.callbackConfig.yesCallback) == "function") this.callbackConfig.yesCallback();
                else if (this.callback && typeof (this.callback) == "function") this.callback(response);
                break;
            case GenericDialogTypes.GenericDialogResult.next:
                if (this.callbackConfig && this.callbackConfig.nextCallback && typeof (this.callbackConfig.nextCallback) == "function") this.callbackConfig.nextCallback();
                else if (this.callback && typeof (this.callback) == "function") this.callback(response);
                break;
            case GenericDialogTypes.GenericDialogResult.back:
                if (this.callbackConfig && this.callbackConfig.backCallback && typeof (this.callbackConfig.backCallback) == "function") this.callbackConfig.backCallback();
                else if (this.callback && typeof (this.callback) == "function") this.callback(response);
                break;
            default:
                if (this.callback) this.callback(response);
                break;
        }
    }

    open(message?: string, header?: string, subtitle?: string, textIcon?: string,
        buttons?: GenericDialogTypes.ButtonPreset, callback?: any): void {



        this.show(message, header, subtitle, textIcon, buttons, callback);
    }

    Open(message?: string, header?: string, subtitle?: string, textIcon?: string,
        buttons?: GenericDialogTypes.ButtonPreset, callback?: any): void {
        this.show(message, header, subtitle, textIcon, buttons, callback);
    }

    /**
     * Vorkonfigurierter Dialog. Je nach Typ sind Einstellungen wie Buttons, Icons und Dialoggröße vorgegeben.
     * @param preset
     * @param callback
     * @param overrides Gezielte Übersteuerung der Einstellungen wie beim gewöhnlichen Setup.
     */
    setup(preset: GenericDialogTypes.DialogPreset, callback: (result: GenericDialogTypes.GenericDialogResult) => void, overrides?: Partial<GenericDialogTypes.DlgConfig>)
    /**
     * Vorkonfigurierter Dialog. Je nach Typ sind Einstellungen wie Buttons, Icons und Dialoggröße vorgegeben.
     * Titel und Nachricht können direkt überreicht werden.
     * @param preset
     * @param callback
     * @param overrides Gezielte Übersteuerung der Einstellungen wie beim gewöhnlichen Setup.
     */
    setup(preset: GenericDialogTypes.DialogPreset, callback: (result: GenericDialogTypes.GenericDialogResult) => void, message: string, header: string, overrides?: Partial<GenericDialogTypes.DlgConfig>)
    setup(preset: GenericDialogTypes.DialogPreset, callback: (result: GenericDialogTypes.GenericDialogResult) => void, message: string, overrides?: Partial<GenericDialogTypes.DlgConfig>)
    setup(config: GenericDialogTypes.DlgConfig)
    setup(configOrPreset: GenericDialogTypes.DlgConfig | GenericDialogTypes.DialogPreset,
        callback?: (result: GenericDialogTypes.GenericDialogResult) => void,
        param1?: Partial<GenericDialogTypes.DlgConfig> | string,
        param2?: Partial<GenericDialogTypes.DlgConfig> | string,
        param3?: Partial<GenericDialogTypes.DlgConfig>) {

        let config: Partial<GenericDialogTypes.DlgConfig>;
        let partConfig: Partial<GenericDialogTypes.DlgConfig>;

        if (param1 && typeof (param1) == "object") {
            partConfig = param1;
        }

        if (param2 && typeof (param2) == "object") {
            partConfig = param2;
        }

        if (param3 && typeof (param3) == "object") {
            partConfig = param3;
        }

        if (param1 || param2 || param3) {
            if (!partConfig) partConfig = {

            };

            if (typeof (param1) == "string" && !partConfig.content) {
                partConfig.content = param1;
               
            }
            if (typeof (param2) == "string" && !partConfig.header) {
                partConfig.header = param2;
            }
        }

        

        if (typeof (configOrPreset) == "string") {
            let preset = configOrPreset as GenericDialogTypes.DialogPreset;
            config = {

            };

            config.content = preset + " - no settings!";
            config.header = preset;

            switch (preset) {
                case "confirmDelete":
                    config.closeOnEscape = true;
                    config.distinctiveNoCallback = "silentclose";
                    config.size = "smaller";
                    config.buttonPreset = "deletecancel";
                    config.titleIconClass = "fas fa-exclamation-triangle";
                    config.contentIconClass = "fas fa-trash warningTXT";
                    config.header = "General_Delete";
                    config.content = "General_ConfirmDeleteMessage";
                    break;

                case "smallError": // kleine Fehlermeldung
                    config.closeOnEnter = true;
                    config.closeOnEscape = true;
                    config.header = TranslationHelpers.tryTranslate("General_ErrorOccurred", false, "General_Error");
                    config.contentIconClass = "fas fa-times-circle warningTXT";
                    config.buttonPreset = "ok";
                    config.content = preset + " - !no message! ";

                    break;

                case "smallYesNoQuestion":// Einfache Frage mit Message.
                case "smallQuestionSilentNo": // Nein führt zu keinem Callback
                    
                    config.closeOnEnter = true;
                    config.closeOnEscape = true;
                    config.header = preset + " - !no title!";// "General_Label_Confirm"; // ohne eigens übergebenen header is es sowieso Käse
                    config.content = preset + " - !no message! ";
                    config.buttonPreset = "yesno";
                    config.contentIconClass = toasterIcons.question;
                    config.distinctiveNoCallback = preset == "smallQuestionSilentNo" ? "silentclose" : null;

                    break;

                case "confirmAction":
                    // TODO: Möchten Sie den Vorgang wirklich fortsetzen?
                    break;

                case "confirmCancelAction":
                    // Möchten Sie den (laufenden) Vorgang wirklich abbrechen?
                    break;

                case "confirmUndoPendingChangesYesNo":
                    // Möchten Sie die Änderungen wirklich verwerfen?
                    break;

                case "smallSuccessMessage":
                    // Vorgang war erfolgreich / Vorgang erfolgreich abgeschlossen/ausgeführt ...
                    break;


                case "savePendingChangesYesNo":
                case "savePendingChangesYesNoCancel":
                    config.closeOnEscape = preset == "savePendingChangesYesNoCancel";
                    config.distinctiveNoCallback = preset == "savePendingChangesYesNoCancel" ? "silentclose" : null;
                    config.content = "General_AskSavePendingChanges";
                    config.size = "smaller";
                    config.header = "General_PendingChanges";
                    config.subtitle = "General_PendingChangesWillBeLost";
                    config.buttonPreset = preset == "savePendingChangesYesNoCancel" ? "yesnocancel" : "yesno";
                    break;
            }
            config.callback = callback;
            // ergänzen/überschreiben mit overrides:
            if (partConfig) {
                for (let prop in partConfig) {
                    config[prop] = partConfig[prop];
                }
            }
        } else {
                config = configOrPreset;
        }

        this.show(config.content,
            config.header,
            config.subtitle,
            config.contentIconClass,
            config.buttonPreset,
            config.callback,
            config);
    }
    Show(message?: string, header?: string, subtitle?: string, textIcon?: string,
        buttons?: GenericDialogTypes.ButtonPreset, callback?: any): void {
        this.show(message, header, subtitle, textIcon, buttons, callback);
    }
    /**
     *
     * @param content Hauptinhalt (wird übersetzt,falls möglich)
     * @param header Titelleiste des Dialogs (wird übersetzt, falls möglich)
     * @param subtitle Untertitel oder zusätzlicher Text unter Hauptinhalt (kleiner)
     * @param textIcon Icon-Klasse, wird neben den Hauptinhalt gestellt
     * @param buttons Voreinstellung für die geläufigsten Button-Kombinationen
     * @param callback Wird nach Auswahl eines Buttons aufgerufen (yes = 2, no = -1, cancel = 0, close = 0, OK = 1, save = 1 ). Falls das Callback als Array übergeben wird, stellt der Dlg sich in den Distinctive-Modus (siehe setDistinctiveCallbacksMode)
     */
    show(content?: string | HTMLElement | dijit._WidgetBase,
        header?: string,
        subtitle?: string,
        textIcon?: string,
        buttons?: GenericDialogTypes.ButtonPreset,
        callback?: Function | Array<Function>,
        additionalConfig?: GenericDialogTypes.DlgAdditionalConfig): void {

        if (typeof (content) != "undefined" && content != null) {
            if (typeof (content) == "string") {
                this._setContentAttr(content);
            } else if (content instanceof HTMLElement) {
                this.addNodeToContent(content);
            } else {
                this.addWidgetToContent(content);
            }
        }
        if (subtitle) {
            this._setSubTitleAttr(subtitle, true);
            //this.hideSubtitleNode(false);
        }
        if (typeof (header) != "undefined" && header != null) {
            this._setHeaderAttr(header);
        }

        if (typeof (textIcon) != "undefined" && textIcon != null) {
            this._setTextIconAttr(textIcon);
        }

        if (additionalConfig) {
            if (typeof (additionalConfig.closeOnEnter) == "boolean") {
                this.closeOnEnter = additionalConfig.closeOnEnter;
            }
            if (typeof (additionalConfig.closeOnEscape) == "boolean") {
                this.closeOnEscape = additionalConfig.closeOnEscape;
            }
            if (typeof (additionalConfig.keepOpen) == "boolean") {
                this.keepOpen = additionalConfig.keepOpen;
            }

           if (typeof (additionalConfig.distinctiveNoCallback) == "function" ||
               additionalConfig.distinctiveNoCallback === null ||
               additionalConfig.distinctiveNoCallback == "silentclose") {
                this.setDistinctiveCallbacksMode(true, null, additionalConfig.distinctiveNoCallback);
            }

            if (additionalConfig.titleIconClass) {
                DOMhelpers.createFontawesomeIcon(additionalConfig.titleIconClass, false, this.headerIconNode, "only");
            }

            if (additionalConfig.frameColor) {
                this.setGlow(additionalConfig.frameColor);
            }

            if (additionalConfig.size) {
                this.setSize(additionalConfig.size);
            }

            if (additionalConfig.additionalButtons?.length) {
                for (let btnConfig of additionalConfig.additionalButtons) {
                    this.addButton(btnConfig.internalName,
                        btnConfig.label,
                        btnConfig.callback,
                        btnConfig.tooltip,
                        btnConfig.styleClass,
                        btnConfig.iconClass,
                        btnConfig.bCloseOnClick,
                        btnConfig.position,
                        btnConfig.enabled);
                }
            }

            if (additionalConfig.callbackConfig) {
                this.callbackConfig = additionalConfig.callbackConfig;
            }
        }

        if (typeof (buttons) == "undefined" || buttons == null) {
            // Standardvariante: einfach nur OK anzeigen und TopClose
            if (this.buttoncount == 0) {
                this._setNoBtnAttr(false);
                this._setYesBtnAttr(false);
                this._setCloseBtnAttr(false);
                this._setOkBtnAttr(false);
                this._setCancelBtnAttr(false);

                this._setTopCloseBtnAttr(true);
                this._setOkBtnAttr(true);
            }
        }
        else {
            this._setNoBtnAttr(false);
            this._setYesBtnAttr(false);
            this._setCloseBtnAttr(false);
            this._setOkBtnAttr(false);
            this._setCancelBtnAttr(false);
            this._setTopCloseBtnAttr(false);

            switch (buttons) {
                case "ok":
                default:
                    this._setOkBtnAttr(true);
                    this._setTopCloseBtnAttr(true);
                    this.closeOnEnter = true;
                    this.closeOnEscape = false;
                    break;

                case "close":
                    this._setCloseBtnAttr(true);
                    this._setTopCloseBtnAttr(true);
                    break;
                case "okcancel":
                    this.closeOnEnter = false;
                    //this.closeOnEscape = false;
                    this._setOkBtnAttr(true);
                    this._setCancelBtnAttr(true);
                    break;
                case "deletecancel":
                    this.closeOnEnter = false;
                   
                    this._setCancelBtnAttr(true);
                    this.addButton(
                        "delete",
                        "General_Delete",
                        lang.hitch(this, this._close, 1),
                        null,
                        "warning",
                        "fas fa-trash",
                        false,
                        "first"
                    );
                    break;
                case "saveclose":
                    this.closeOnEscape = false;
                    this.closeOnEnter = false;
                    this._setCloseBtnAttr(true);
                    this.addButton(
                        "save",
                        "General_Save",
                        lang.hitch(this, this._close, 1),
                        null,
                        "accentBG",
                        "fas fa-save",
                        false,
                        "first"
                    );
                    break;
                case "submitcancel":
                    this.closeOnEscape = false;
                    this.closeOnEnter = false;
                    this._setCancelBtnAttr(true);
                    this.addButton(
                        "submit",
                        "General_Submit",
                        lang.hitch(this, this._close, 1),
                        null,
                        "accentBG",
                        "fas fa-check",
                        false,
                        "first"
                    );
                    break;
                case "yesno":
                    this.closeOnEscape = false;
                    this.closeOnEnter = false;
                    this._setYesBtnAttr(true);
                    this._setNoBtnAttr(true);
                    break;

                case "yesnocancel":
                    this.closeOnEnter = false;
                    this._setYesBtnAttr(true);
                    this._setNoBtnAttr(true);
                    this._setCancelBtnAttr(true);
                    break;


            }

            if (typeof (callback) != "undefined" && callback != null) {
                if (callback.length >= 2) {
                    this.setDistinctiveCallbacksMode(true, callback[0], callback[1]);
                } else if (typeof (callback) == "function") {
                    this._setCallbackAttr(callback);
                }
            }
        }

        if (this._isMobile === true) {
            try {
                // history stack
                if (history?.state?.name == this.activeState["name"] || history?.state?.name == this.closedState["name"]) {
                    history.replaceState(this.activeState, "GenericDialog open", this.defaultUrl + this.dlgOpenUrl);
                } else {
                    history.pushState(this.activeState, "GenericDialog open", this.defaultUrl + this.dlgOpenUrl);
                }

                if (window["widgetsRoutingOrder"].indexOf(this.id) == -1) {
                    window["widgetsRoutingOrder"].push(this.id);
                }
            } catch (ex) {

            }
        }
        this.hideNode(this.leftActionContainerNode, this.secondaryButtonsAsMenu);


        this.UiModder.domClass.add(this.modalDlgNode, "outfade");
        this.UiModder.domClass.add(this.modalDlgNode, "w3-show");

        if (this.is_active != true) {
            this._handleRootOverflow();
        }

        setTimeout(lang.hitch(this, this.UiModder.domClass.remove, this.modalDlgNode, "outfade"), 20);
        //this.UiModder.domClass.remove(this.modalDlgNode, "beforeAnimation");
        this.emit("shown", this);

        this.is_active = true;

        this.updateMenuButtonIcons();
    }

    /**
     * Schließt den Dialog, auch wenn das keepOpen-Flag auf true steht
     * @param result Numerischer Wert oder Callback. Wenn leer (undefined): der Dialog schließt im "silent"-Modus
     * @param silent Wenn true, wird kein Callback mehr ausgelöst.
     */
    close(result?: Function | number, silent?: boolean): void {
        this.Close(result, silent);
    }
    /**
     * Schließt den Dialog, auch wenn das keepOpen-Flag auf true steht
 * @param result Numerischer Wert oder Callback. Wenn leer (undefined): der Dialog schließt im "silent"-Modus
     * @param silent Wenn true, wird kein Callback mehr ausgelöst.
     */
    Close(result?: Function | number, silent?: boolean): void {
        if (typeof (result) == "undefined") silent = true;

        if (silent === true) {
            this.callback = null;

            if (typeof (result) == "function") {
                result = -1;
            }
        }
        this.keepOpen = false;
        this._close(result);
    }
    /**
 * Schließt den Dialog, auch wenn das keepOpen-Flag auf true steht
 * @param result Numerischer Wert oder Callback.
 * @param silent Wenn true, wird kein Callback mehr ausgelöst.
 */
    hide(result?: Function | number, silent?: boolean): void {
        this.Close(result, silent);
    }
    /**
 * Schließt den Dialog, auch wenn das keepOpen-Flag auf true steht
 * @param result Numerischer Wert oder Callback.
 * @param silent Wenn true, wird kein Callback mehr ausgelöst.
 */
    Hide(result?: Function | number, silent?: boolean): void {
        this.Close(result, silent);
    }

    setCloseOnEnter(value = true): void {
        this.closeOnEnter = value;
    }
    _setCloseOnenterAttr(value = true): void {
        this.setCloseOnEnter(value);
    }
    setCloseOnEscape(value = true): void {
        this.closeOnEscape = value;
    }
    _setCloseOnEscapeAttr(value = true): void {
        this.setCloseOnEscape(value);
    }

    disableButton(buttonName: string) {
        let button = this.getButtonByName(buttonName);
        if (button) {
            this.UiModder.domClass.add(button.node, "w3-disabled");
            button.enabled = false;

            if (button.isSecondary && this.secondaryButtonsAsMenu && this.menu) {
                this.drawMenuEntries();
            }
            return;
        }

        if (!buttonName) return;
        let node: HTMLElement = null;
        switch (buttonName.toLowerCase()) {
            case "ok":
                node = this.btnOk;
                break;
            case "yes":
                node = this.btnYes;
                break;
            case "no":
                node = this.btnNo;
                break;
            case "next":
                node = this.btnNext;
                break;
            case "previous":
            case "back":
                node = this.btnBack;
                break;

            case "cancel":
                node = this.btnCancel;
                break;

        }

        if (node) {
            this.UiModder.domClass.add(node, "w3-disabled");
        }
    }
    enableButton(buttonName: string, bEnable?: boolean) {
        if (bEnable === false) {
            this.disableButton(buttonName);
            return;
        }
        let button = this.getButtonByName(buttonName);
        if (button) {
            button.enabled = true;
            this.UiModder.domClass.remove(button.node, "w3-disabled");

            if (button.isSecondary && this.secondaryButtonsAsMenu && this.menu) {
                this.drawMenuEntries();
            }
            return;
        }

        if (!buttonName) return;
        let node: HTMLElement = null;
        switch (buttonName.toLowerCase()) {
            case "ok":
                node = this.btnOk;
                break;
            case "yes":
                node = this.btnYes;
                break;
            case "no":
                node = this.btnNo;
                break;
            case "next":
                node = this.btnNext;
                break;
            case "previous":
            case "back":
                node = this.btnBack;
                break;

            case "cancel":
                node = this.btnCancel;
                break;

        }

        if (node) {
            this.UiModder.domClass.remove(node, "w3-disabled");
        }
    }
    /**
     * Alle Buttons (auch custom) deaktivieren oder aktivieren.
     * Ändert nicht die Sichtbarkeit der Buttons.
     */
    disableAllButtons(bDisable?: boolean) {

        this.UiModder.domClass.toggle(this.btnBack, "w3-disabled", bDisable !== false);
        this.UiModder.domClass.toggle(this.btnNext, "w3-disabled", bDisable !== false);
        this.UiModder.domClass.toggle(this.btnYes, "w3-disabled", bDisable !== false);
        this.UiModder.domClass.toggle(this.btnNo, "w3-disabled", bDisable !== false);
        this.UiModder.domClass.toggle(this.btnOk, "w3-disabled", bDisable !== false);
        this.UiModder.domClass.toggle(this.btnCancel, "w3-disabled", bDisable !== false);
        this.UiModder.domClass.toggle(this.btnClose, "w3-disabled", bDisable !== false);
        this.UiModder.domClass.toggle(this.topCloseBtn, "w3-disabled", bDisable !== false);

        for (let button of this._buttons) {
            this.UiModder.domClass.toggle(button.node, "w3-disabled", bDisable !== false);
        }
    }

    enableContentOverflow(bValue?: boolean) {
        if (bValue !== true && bValue !== false) {
            bValue = true;
        }

        if (bValue == true) {
            this.UiModder.domClass.add(this.textNode, 'overflow-visible');
            this.UiModder.domClass.add(this.modalDlgContentNode, 'overflow-visible');
            this.UiModder.domClass.add(this.contentContainer, 'overflow-visible');
        } else {
            this.UiModder.domClass.remove(this.textNode, 'overflow-visible');
            this.UiModder.domClass.remove(this.modalDlgContentNode, 'overflow-visible');
            this.UiModder.domClass.remove(this.contentContainer, 'overflow-visible');
        }
    }

    private _close(result?: Function | GenericDialogTypes.GenericDialogResult): void {
        if (this._isMobile === true) {
            try {
                if (history?.state?.name != this.initialState["name"]) history.replaceState(this.closedState, "GenericDialog closed", this.defaultUrl);
                if (window["widgetsRoutingOrder"].indexOf(this.id) != -1) {
                    window["widgetsRoutingOrder"].splice(window["widgetsRoutingOrder"].indexOf(this.id), 1);
                }
            } catch (ex) {

            }
        }

        let bWasActive = this.is_active;


        if (this.destroyOnClose === true && this.keepOpen != true) {
            //  selbstzerstörung in 1 Sekunde :-)
            //
            this.UiModder.domClass.add(this.modalDlgNode, "outfade");
            setTimeout(lang.hitch(this, this.UiModder.domClass.remove, this.modalDlgNode, "w3-show"), 150);

            this.is_active = false;

            if (bWasActive == true) {
                this.emit("closed", { result: result });
            }

            setTimeout(lang.hitch(this, "destroy"), 1000);
        }
        else if (this.keepOpen != true) {
            this.UiModder.domClass.add(this.modalDlgNode, "outfade");
            setTimeout(lang.hitch(this, this.UiModder.domClass.remove, this.modalDlgNode, "w3-show"), 150);

            this.is_active = false;

            if (bWasActive == true) {
                this.emit("closed", { result: result });
            }
        }

        if (bWasActive && bWasActive != this.is_active) this._handleRootOverflow(-1);


        if (typeof (result) == "undefined") {
            result = GenericDialogTypes.GenericDialogResult.close;
        }

        if (typeof (result) == "function") {
            result();
        } else if (typeof (result) == "number") {
            //  callback-function nahezu in echtzeit aufrufen. aber asynchron ...
            //
            if (typeof (this.callback) == "function" || this.callbackConfig) {
                if (this.isUseDistinctiveCallbacks != true || result >= GenericDialogTypes.GenericDialogResult.ok) {
                    setTimeout(lang.hitch(this, this._dialogCallback, result), 1);
                    //setTimeout(lang.partial(this.callback, result), 1);
                } else if (this.isUseDistinctiveCallbacks == true && result <= GenericDialogTypes.GenericDialogResult.cancel) {
                    if (typeof (this.callbackCancelNoClose) != "undefined") {
                        if (this.callbackCancelNoClose) {
                            setTimeout(lang.partial(this.callbackCancelNoClose, result), 1);
                        } else {
                            this.close(-1, true);
                        }
                    } else if (this.keepOpen == true) {
                        // dlg würde jetzt nicht zugehen und sich aber auch nicht melden, dass geklickt wurde!
                        // in dem fall schießen wir ein silent close hinterher:
                        this.close(-1, true);
                    }
                }
            }
        }
    }

    private _buttons: Array<DlgButton> = [];
    private _buttonMenus: Array<SecondaryMenuGroup> = [];


    addButtonMenu(
        name: string,
        label?: string,
        iconClass?: string,
        bIsGroupNextLevel?: boolean,
        parentGroupName?: string
    ) {
        let menuEntry: SecondaryMenuGroup = {
            name: name,
            label: label,
            iconClass: iconClass,
            bIsGroupNextLevel: bIsGroupNextLevel,
            parentGroupName: parentGroupName
        }

        this._buttonMenus.push(menuEntry);

        if (this.menu) {
            this.drawMenuEntries();
        }
    }

    /**
    * Neuen Button hinzufügen
    * @param internalName Interne, eindeutige Bezeichnung des Buttons (nicht zur Anzeige)
    * @param label Beschriftung des Buttons
     * @param callback Funktion die beim Klicken des Buttons aufgerufen wird; wenn null: Button wird ausgeblendet/nicht erzeugt!
    * @param styleClass Beliebige weitere Styleklassen für den Button, zusätzlich zum Standard.
    * @param iconClass Eine Fontawesome-Klasse zB. 'fas fa-bookmark'
     * @param bCloseOnClick Dialog soll beim Klicken schließen oder nicht schließen. Falls nicht angegeben, wird das keepOpen-Flag des Dialogs herangezogen.
     * @param position 'first', 'last' oder Nummer. Standard: 'first'. Hinweis: 'first' heißt im GenericDialog "am weitesten rechts platziert" bzw. prominenter. Left: separater, links orientierter Container.
    */
    addButton(
        internalName: string,
        label: string,
        callback: Function,
        tooltip?: string,
        styleClass?: string,
        iconClass?: string,
        bCloseOnClick?: boolean,
        position?: "first" | "last" | "left first" | "left last" | "top" | "top first" | "top last" | number,
        enabled?: boolean,
        hasNextLevel?: boolean,
        hasPreviousLevel?: boolean,
        groupname?: string
    ) {

        // weil die Position mittlerweile per order-Attribut im HTML geregelt wird, muss der Button sich an den anderen orientieren...
        let replacementOrder = undefined;
        if (position == "last") replacementOrder = 999 + (this._buttons ? this._buttons.length * 10 : 0);
        if (position == "first") replacementOrder = -1 - (this._buttons ? this._buttons.length * 10 : 0);;

        this.addButtonEx({
            callback: callback,
            internalName: internalName,
            label: label,
            bCloseOnClick: bCloseOnClick,
            enabled: enabled,
            groupname: groupname,
            hasNextLevel: hasNextLevel,
            hasPreviousLevel: hasPreviousLevel,
            iconClass: iconClass,
            order: typeof (position) == "number" ? position : replacementOrder,
            placement: typeof (position) == "string" ? position : "first",
            styleClass: styleClass,
            tooltip: tooltip
        })
    }/**
    * Neuen Button hinzufügen
    * @param internalName Interne, eindeutige Bezeichnung des Buttons (nicht zur Anzeige)
    * @param label Beschriftung des Buttons
     * @param callback Funktion die beim Klicken des Buttons aufgerufen wird; wenn null: Button wird ausgeblendet/nicht erzeugt!
    * @param styleClass Beliebige weitere Styleklassen für den Button, zusätzlich zum Standard.
    * @param iconClass Eine Fontawesome-Klasse zB. 'fas fa-bookmark'
     * @param bCloseOnClick Dialog soll beim Klicken schließen oder nicht schließen. Falls nicht angegeben, wird das keepOpen-Flag des Dialogs herangezogen.
     * @param placement 'first', 'last', 'left first', 'left last', 'top', 'top first', 'top last' Standard: 'first'. Hinweis: 'first' heißt im GenericDialog "am weitesten rechts platziert" bzw. prominenter. Left: separater, links orientierter Container.
     * @param order Sortierreihenfolge innerhalb des Placements. Standardbuttons sind zwischen 100 (am weitesten rechts) und 200 (am weitesten links) eingereiht. (ok = 100, cancel = 190, close = 120, yes = 150, no = 160, next = 170, previous = 180)
    */
    addButtonEx(config: {
        internalName: string,
        label: string,
        callback: Function,
        tooltip?: string,
        styleClass?: string,
        iconClass?: string,
        bCloseOnClick?: boolean,
        placement?: "first" | "last" | "left first" | "left last" | "top" | "top first" | "top last",
        order?: number,
        enabled?: boolean,
        hasNextLevel?: boolean,
        hasPreviousLevel?: boolean,
        groupname?: string
    }): HTMLElement {
        if (!config) return;
        let internalName = config.internalName;
        let placement = config.placement;
        let order = config.order;
        let bCloseOnClick = config.bCloseOnClick;
        let tooltip = config.tooltip;
        let styleClass = config.styleClass;
        let iconClass = config.iconClass;
        let label = config.label;
        let callback = config.callback;
        let enabled = config.enabled;
        let hasNextLevel = config.hasNextLevel;
        let hasPreviousLevel = config.hasPreviousLevel;
        let groupname = config.groupname;

        switch (styleClass) {
            case "primary":
            case "secondary":
            case "tertiary":
                styleClass += "BG";
                break;
        }

        if (!internalName) return;

        let bIsSecondary = false;

        this.removeButton(internalName);

        if (placement == null || typeof (placement) == "undefined") {
            placement = "first";
        }

        let target = this.rightActionContainerNode;

        if (placement == "left first" || placement == "left last") {
            target = this.leftActionContainerNode;

            bIsSecondary = true;

            placement = placement == "left last" ? "last" : "first";

        }
        let node: HTMLElement = null;

        if (placement.indexOf("top") == 0) {
            target = this.titleActionContainer;
            if (placement == "top first") {
                placement = "last"; // "first" heißt im Dlg "rechts", also im Dom last
            } else {
                placement = "first";
            }
            node = this.UiModder.domConstruct.create("button", {
                "className": "dlgAction headingButton",
                "innerHTML": "",
                "onclick": lang.hitch(this, this._onClick_CustomButton, internalName)
            }, target, placement);

            placement = "top";

        } else {
            node = this.UiModder.domConstruct.create("button", {
                "className": "buttonBase dlgAction padding",
                "innerHTML": "",
                "onclick": lang.hitch(this, this._onClick_CustomButton, internalName)
            }, target, placement);
        }

        if (tooltip) {
            node.title = tooltip;
        }

        if (typeof (order) == "number") {
            node.style.setProperty("order", order.toString());
        }

        if (styleClass) {
            this.UiModder.domClass.add(node, styleClass);
        }

        if (iconClass) {
            let icon = this.UiModder.domConstruct.create("i", {
                "className": iconClass
            }, node);
        }

        if (label) {
            label = TranslationHelpers.tryTranslate(label);

            let title = this.UiModder.domConstruct.create("span", {
                "className": "",
                "innerHTML": label
            }, node);
        }
        //ANCHOR
        let regEntry: DlgButton = {
            name: internalName,
            label: label,
            callback: callback,
            styleclass: styleClass,
            iconclass: iconClass,
            tooltip: tooltip,
            closeOnClick: bCloseOnClick,
            node: node,
            isSecondary: bIsSecondary,
            enabled: enabled != false,
            hasNextLevel: hasNextLevel,
            hasPreviousLevel: hasPreviousLevel,
            groupname: groupname,
            order: config.order
        };


        if (placement == "first") {
            this._buttons.unshift(regEntry);
        } else {
            this._buttons.push(regEntry);
        }

        if (bIsSecondary && this.menu) {
            this.drawMenuEntries();
        }

        if (bIsSecondary && this.is_active) {
            this.updateMenuButtonIcons();
        }


        this.buttoncount++;

        this.showActionContainer();

        if (enabled === false) this.disableButton(internalName);

        //cypress hook
        node.setAttribute("data-cy", "GenericDlg_Btn:" + (internalName ?? ""));
        node.setAttribute("data-e2e-role", "button");
        return node;
    }

    removeButton(name: string) {
        let index = this.getButtonIndexByName(name);
        if (index != -1) {
            let button = this._buttons[index];
            this.UiModder.domConstruct.destroy(button.node);

            this._buttons.splice(index, 1);
            this.buttoncount--;

            this.showActionContainer();

            if (button.isSecondary) {
                if (this.menu) {
                    this.drawMenuEntries();
                }
                this.updateMenuButtonIcons();
            }
        }
    }

    private updateMenuButtonIcons() {
        this.disableNode(this.btnSecondaryMenu);
        if (this._updateMenuButtonIconsHandle) clearTimeout(this._updateMenuButtonIconsHandle);

        this._updateMenuButtonIconsHandle = setTimeout(lang.hitch(this, this._updateMenuButtonIcons), 20);
    }
    private _updateMenuButtonIconsHandle: any = null;

    private _updateMenuButtonIcons() {
        if (!this.is_active) return; // Performance

        let defaultIcon = "fas fa-square transparentTXT";

        this.UiModder.domConstruct.empty(this.secondaryIconsContainer);

        let knownIcons = [];
        this.hideNode(this.furtherEntriesIcon);

        for (let buttonMenu of this._buttonMenus) {
            if (buttonMenu.bIsGroupNextLevel && !buttonMenu.parentGroupName && this.buttonMenuHasEntry(buttonMenu)) {
                let icon = defaultIcon;
                if (buttonMenu.iconClass) icon = buttonMenu.iconClass;

                let knownIconIndex = knownIcons.indexOf(icon);
                if (knownIconIndex == -1) {
                    knownIcons.push(icon);


                    if (knownIcons.length == 5) {
                        this.hideNode(this.furtherEntriesIcon, false);
                        break;
                    }

                    let iconContainerNode = this.UiModder.domConstruct.create("span", {
                        className: "iconContainer"
                    }, this.secondaryIconsContainer);

                    let iconNode = this.createFontawesomeIcon(icon, "", iconContainerNode);

                }
            }
        }

        for (let button of this._buttons) {
            if (button.isSecondary && !button.hasPreviousLevel) {
                let icon = defaultIcon;
                if (button.iconclass) icon = button.iconclass;

                let knownIconIndex = knownIcons.indexOf(icon);
                if (knownIconIndex == -1) {
                    knownIcons.push(icon);


                    if (knownIcons.length == 5) {
                        this.hideNode(this.furtherEntriesIcon, false);
                        break;
                    }

                    let iconContainerNode = this.UiModder.domConstruct.create("span", {
                        className: "iconContainer"
                    }, this.secondaryIconsContainer);

                    let iconNode = this.createFontawesomeIcon(icon, "", iconContainerNode);

                }
            }
        }


        //console.log(this.id + "menu icons", knownIcons, this._buttons);
        this.UiModder.domClass.toggle(this.secondaryIconsContainer, "icongrid", knownIcons.length > 0);

        this.disableNode(this.btnSecondaryMenu, false);
        //    if (!knownIcons.length) {
        //        this.createFontawesomeIcon("fas fa-ellipsis-h", "", this.btnSecondaryMenuIcons);
        //    } else {
        //        this.createFontawesomeIcon("fas fa-caret-down paddingSmallLeft", "", this.btnSecondaryMenu);
        //    }
    }

    private buttonMenuHasEntry(buttonMenu: SecondaryMenuGroup) {
        for (let button of this._buttons) {
            if (button.hasPreviousLevel && button.groupname === buttonMenu.name) return true;
        }
        return false;
    }


    private drawMenuEntries() {
        let menu = this.menu;
        if (!menu) return;

        this.menu.clearEntries();

        for (let buttonMenu of this._buttonMenus) {
            menu.addGroup(
                buttonMenu.name,
                buttonMenu.label,
                buttonMenu.iconClass,
                buttonMenu.bIsGroupNextLevel,
                buttonMenu.parentGroupName
            )
        }

        for (let button of this._buttons) {
            if (button.isSecondary) {
                menu.addEntry({
                    icon: button.iconclass,
                    callback: lang.hitch(this, this._menuEntryCallback, button.name),
                    label: button.label,
                    groupname: button.groupname,
                    coloration: null,
                    enabled: button.enabled,
                    hasNextLevel: button.hasNextLevel,
                    hasPreviousLevel: button.hasPreviousLevel
                });
            }
        }
    }
    private _menuEntryCallback(name: string, evt: MouseEvent) {
        this._onClick_CustomButton(name, evt);

        this.menu = null;
    }
    private menu: MdsLax<InstanceType<typeof FloatingMenu>> = null;
    private _onClick_Menu(evt: MouseEvent) {

        if (!this.secondaryButtonsAsMenu) return;

        if (this.menu) {
            this.menu.close();
            return;
        }

        let menu = new FloatingMenu();
        menu.on("close", lang.hitch(this, function () { this.menu = null; }));
        this.menu = menu;

        this.drawMenuEntries();

        menu.open(evt);//, null, null, this.menuActionContainerNode);
    }
    private _onClick_CustomButton(name: string, evt: MouseEvent) {

        let button = this.getButtonByName(name);

        if (button) {
            if (typeof (button.callback) == "function") {

                button.callback(evt);

            }

            if (button.closeOnClick === true || (this.keepOpen != true && button.closeOnClick !== false)) {
                this.close(-1, true);
            }
        }

        if (this.propagateClick !== true && evt) {
            evt.stopPropagation();
        }

    }


    private getButtonIndexByName(name: string): number {
        let index = 0;
        for (let button of this._buttons) {

            if (button.name == name) {
                return index;
            }

            index++;
        }

        return -1;
    }


    getButtonByName(name: string): DlgButton {

        let index = this.getButtonIndexByName(name);
        if (index != -1) return this._buttons[index];

        return null;
    }


    /**
    * @param text Beschriftung des Buttons
     * @param callback Funktion die beim Klicken des Buttons aufgerufen wird; wenn null: Button wird ausgeblendet/nicht erzeugt!
    * @param iconClass Eine Fontawesome-Klasse zB. 'fas fa-bookmark'
     * @param bCloseOnClick Dialog soll beim Klicken schließen oder nicht schließen
     * @param bSecondaryButton Es soll ein weniger prominenter Button verwendet werden (tertiäre Färbung, Platzierung links statt rechts)
    */
    setUserdefinedButton(text: string, iconClass: string, callback: Function, bCloseOnClick?: boolean, bSecondaryButton?: boolean) {

        let style = "accentBG";
        if (bSecondaryButton == false) {
            style = "";
        }

        if (typeof (callback) != "function") {
            this.removeButton("default_userdefined");
            return;
        }

        this.addButton("default_userdefined", text, callback, null, style, iconClass, bCloseOnClick, bSecondaryButton ? "last" : "first");
    }

    removeUserdefinedButton(name?: string): void {
        if (!name) {
            name = "default_userdefined";
        }

        this.removeButton(name);
    }

    _setYesBtnAttr(show: boolean, enable: boolean = true): void {
        let currentState = !this.UiModder.domClass.contains(this.btnYes, "w3-hide");

        if (show === true) {
            this.UiModder.domClass.remove(this.btnYes, "w3-hide");
            if (currentState != show) {
                this.buttoncount++;
            }
        } else {
            this.UiModder.domClass.add(this.btnYes, "w3-hide");
            if (currentState != show) {
                this.buttoncount--;
            }
        }

        this.UiModder.domClass.toggle(this.btnYes, "w3-disabled", enable === false);

        this._buttons.push({
            callback: null,
            enabled: enable != false && show == true,
            iconclass: null,
            node: this.btnYes,
            name: "yes",
            label: this.btnYes.innerHTML,
            tooltip: null,
            styleclass: this.btnYes.className,
            isSecondary: false,
            order: null
        });

        this.showActionContainer();
    }

    _setNoBtnAttr(show: boolean, enable: boolean = true): void {
        let currentState = !this.UiModder.domClass.contains(this.btnNo, "w3-hide");

        if (show === true) {
            this.UiModder.domClass.remove(this.btnNo, "w3-hide");
            if (currentState != show) {
                this.buttoncount++;
            }
        } else {
            this.UiModder.domClass.add(this.btnNo, "w3-hide");
            if (currentState != show) {
                this.buttoncount--;
            }
        }

        this.UiModder.domClass.toggle(this.btnNo, "w3-disabled", enable === false);

        this._buttons.push({
            callback: null,
            enabled: enable != false && show == true,
            iconclass: null,
            node: this.btnNo,
            name: "no",
            label: this.btnNo.innerHTML,
            tooltip: null,
            styleclass: this.btnNo.className,
            isSecondary: false,
            order: null
        });
        this.showActionContainer();
    }

    _setOkBtnAttr(show: boolean, enable: boolean = true): void {
        let currentState = !this.UiModder.domClass.contains(this.btnOk, "w3-hide");

        if (show === true) {
            this.UiModder.domClass.remove(this.btnOk, "w3-hide");
            if (currentState != show) {
                this.buttoncount++;
            }
        } else {
            this.UiModder.domClass.add(this.btnOk, "w3-hide");
            if (currentState === true) {
                this.buttoncount--;
            }
        }

        this._buttons.push({
            callback: null,
            enabled: enable != false && show == true,
            iconclass: null,
            node: this.btnOk,
            name: "ok",
            label: this.btnOk.innerHTML,
            tooltip: null,
            styleclass: this.btnOk.className,
            isSecondary: false,
            order: null
        });

        this.UiModder.domClass.toggle(this.btnOk, "w3-disabled", enable === false);

        this.showActionContainer();
    }

    //_setCloseAttr(value: boolean): void { // fun fact: durch das Definieren der Close-Funktion weiter oben wird hier dieser Setter ausgelöst
    //    this.set("CloseBtn", value);
    //}

    _setCloseBtnAttr(show: boolean, enable: boolean = true): void {
        let currentState = !this.UiModder.domClass.contains(this.btnClose, "w3-hide");

        if (show === true) {
            this.UiModder.domClass.remove(this.btnClose, "w3-hide");
            if (currentState != show) {
                this.buttoncount++;
            }
        } else {
            this.UiModder.domClass.add(this.btnClose, "w3-hide");
            if (currentState === true) {
                this.buttoncount--;
            }
        }

        this.UiModder.domClass.toggle(this.btnClose, "w3-disabled", enable === false);

        this._buttons.push({
            callback: null,
            enabled: enable != false && show == true,
            iconclass: null,
            node: this.btnClose,
            name: "close",
            label: this.btnClose.innerHTML,
            tooltip: null,
            styleclass: this.btnClose.className,
            isSecondary: false,
            order: null
        });

        this.showActionContainer();
    }

    _setTopCloseBtnAttr(show: boolean) {
        if (show === true) {
            //this.UiModder.domClass.remove(this.topCloseBtn, "w3-hide");
            this.hideNode(this.topCloseBtn, false, false);
        } else {
            this.hideNode(this.topCloseBtn, false, true);
            //this.UiModder.domClass.add(this.topCloseBtn, "w3-hide");
        }
    }

    _setCancelBtnAttr(show: boolean, enable: boolean = true): void {
        let currentState = !this.UiModder.domClass.contains(this.btnCancel, "w3-hide");

        if (show === true) {
            this.UiModder.domClass.remove(this.btnCancel, "w3-hide");
            if (currentState != show) {
                this.buttoncount++;
            }
        } else {
            this.UiModder.domClass.add(this.btnCancel, "w3-hide");
            if (currentState === true) {
                this.buttoncount--;
            }
        }

        this.UiModder.domClass.toggle(this.btnCancel, "w3-disabled", enable === false);

        this._buttons.push({
            callback: null,
            enabled: enable != false && show == true,
            iconclass: null,
            node: this.btnCancel,
            name: "cancel",
            label: this.btnCancel.innerHTML,
            tooltip: null,
            styleclass: this.btnCancel.className,
            isSecondary: false,
            order: null
        });

        this.showActionContainer();
    }

    _setBackBtnAttr(value: boolean, enable: boolean = true): void {
        let currentState = !this.UiModder.domClass.contains(this.btnBack, "w3-hide");

        if (value === true) {
            this.UiModder.domClass.remove(this.btnBack, "w3-hide");
            if (currentState != value) {
                this.buttoncount++;
            }
        } else {
            this.UiModder.domClass.add(this.btnBack, "w3-hide");
            if (currentState === true) {
                this.buttoncount--;
            }
        }

        this.showActionContainer();
    }

    _setNextBtnAttr(value: boolean, enable: boolean = true): void {
        let currentState = !this.UiModder.domClass.contains(this.btnNext, "w3-hide");

        if (value === true) {
            this.UiModder.domClass.remove(this.btnNext, "w3-hide");
            if (currentState != value) {
                this.buttoncount++;
            }
        } else {
            this.UiModder.domClass.add(this.btnNext, "w3-hide");
            if (currentState === true) {
                this.buttoncount--;
            }
        }

        this.showActionContainer();
    }

    _setVerticalGrowingAllowedAttr(bAllowGrowing: boolean = true) {
        this.allowVerticalGrowing(bAllowGrowing == true);
    }

    allowVerticalGrowing(bAllowGrowing: boolean = true) {
        this.UiModder.domClass.toggle(this.modalDlgContentNode, "vgrowing", bAllowGrowing === true);
    }

    private _onRequestNewContextButton(config: Tabbing.ContextActionButtonRequest): Tabbing.ContextActionButtonDescriptor {
        let result: Tabbing.ContextActionButtonDescriptor = null;

        if (this.getButtonByName(config.name)) return;

        let placement = "left last";
        switch (config.placement) {
            case "actionbar":
                placement = "last";
                break;
        }

        switch (config.name) {
            case "clone":
            case "copy":
            case "reload":
                placement = "left last";
                break;
        }

        this.addButton(config.name,
            config.label,
            config.callback,
            null,
            config.styleClass,
            config.iconClass,
            false,
            placement as any,
            config.enabled);
    }

    private _onRequestContextButtonDisable(target: { name: string, enable: boolean }) {
        this.enableButton(target.name, target.enable === true);
    }
    private _onRequestContextButtonRemove(name: string) {
        this.removeButton(name);
    }
    private _onRequestRename(newTitle: string) {
        this._setHeaderAttr(newTitle);
    }

    private _handleRootOverflow(incrementCount: number = 1) {
        let countStr = this.UiModder.domAttr.get(document.documentElement, "data-genericDlgCount");
        let count = 0;

        //console.trace(this.id + " _handleRootOverflow", countStr);

        if (!countStr) {
        } else {
            try {
                count = parseInt(countStr);
            } catch (ex) {

            }
        }

        count += incrementCount;

        if (count) {
            this.UiModder.domAttr.set(document.documentElement, "data-genericDlgCount", count.toString());
            this.UiModder.domStyle.set(document.documentElement as HTMLElement, "overflow", "hidden");
        } else {
            this.UiModder.domAttr.set(document.documentElement, "data-genericDlgCount", "");
            this.UiModder.domStyle.set(document.documentElement as HTMLElement, "overflow", "");
        }

    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }

    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        // cypress hook (analog zu den dynamischen Buttons, s. createButton): statischer Sekundaermenue-Button
        this.btnSecondaryMenu.setAttribute("data-cy", "GenericDlg_Btn:secondaryMenu");
        this.btnSecondaryMenu.setAttribute("data-e2e-role", "button");

        this.buttoncount = 0;
        this.placeAt(document.body);

        this._buttons = [];

        // touchscreen
        if ("ontouchstart" in document.documentElement) {
            this._isMobile = true;
        }

        if (this._isMobile === true) {

            // das ganze alte History-Zeug, eher fehleranfällig...
            try {
                // eine globale registry
                if (!window["widgetsRoutingOrder"]) window["widgetsRoutingOrder"] = [];

                this.activeState["widgetID"] = this.id;
                this.closedState["widgetID"] = this.id;
                this.customState["widgetID"] = this.id;

                //url bereinigen
                this.defaultUrl = document.location.href;
                let index: number = this.defaultUrl.indexOf(this.dlgOpenUrl);
                if (index != -1) this.defaultUrl = this.defaultUrl.slice(0, index);

                //initial state setzen:
                if (history.state != null && this.activeState["name"] != history?.state?.name && this.closedState["name"] != history?.state?.name) {
                    this.initialState = history.state;
                } else {
                    // der user hat sich mit vor- zurück und reload ausgetobt:
                    this.initialState = this.customState;
                    history.replaceState(this.initialState, "Dialog: Custom initial state", this.defaultUrl);
                }

                // history-Handling gehört verbessert. bei window.open kommt es zu Problemen, #24299
                //    window.addEventListener("popstate", lang.hitch(this, "_onpopstateCallback_setup"));
                //    this._onpopstateCallback_setup();

            } catch (ex) {

            }
        }
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(GenericDialog);
